import { useSeoMeta, useSwitchLocalePath } from '#imports'
import { locales } from '~/utils/locale'
import { SITE_NAME } from '~/utils'

export function useDefaultSeo() {
  const structData = {
    '@context': 'https://schema.org',
    '@graph': [{
      '@type': 'Organization',
      '@id': 'https://www.ttx.vip/#Organization',
      'name': 'TT',
      'alternateName': [
        'TT.vip',
        'TT exchange',
        'TT crypto exchange',
        'TT cryptocurrency exchange',
      ],
      'url': 'https://www.ttx.vip/',
      'logo': {
        '@type': 'ImageObject',
        '@id': 'https://www.ttx.vip/#Logo',
        'contentUrl': 'https://www.ttx.vip/favicon.ico',
        'url': 'https://www.ttx.vip/favicon.ico',
        'name': 'TT logo',
        'caption': 'TT logo',
      },
      'brand': {
        '@type': 'Brand',
        'name': 'TT',
        'slogan': 'Secure, Fast, Reliable',
        'logo': {
          '@id': 'https://www.ttx.vip#Logo',
        },
      },
      'contactPoint': [{
        '@type': 'ContactPoint',
        'contactType': 'Technical Support Email',
        'name': 'TT Support Email',
        'email': 'support@TT.vip',
        'url': 'https://ttx.zendesk.com/hc/en-001',
      }, {
        '@type': 'ContactPoint',
        'contactType': 'Business Email',
        'name': 'TT Business Email',
        'email': 'business@TT.vip',
        'url': 'https://www.ttx.vip/',
      }],
      'foundingDate': '2013-04-13',
      'keywords': [
        'TT',
        'TTX.vip',
        'TT crypto exchange',
        'TT cryptocurrency exchange',
        'TT exchange',
      ],
      'knowsAbout': [
        'crypto',
        'crypto exchange',
        'crypto trading',
        'cryptocurrency',
        'cryptocurrency exchange',
        'cryptocurrency trading',
        'bitcoin',
        'ethereum',
      ],
      'knowsLanguage': locales.map(i => ({
        '@type': 'Language',
        'name': i.title,
        'alternateName': [
          i.code,
          i.title,
        ],
        'mainEntityOfPage': `https://www.ttx.vip/${i.code === 'en' ? '' : i.code}`,
      })),
      'disambiguatingDescription': 'TT.vip - cryptocurrency exchange and crypto trading platform',
      'description': 'TT is a secure, fast, and reliable crypto trading exchange, offering the service and tools to buy, sell, and trade on the go.',
      'sameAs': [
        'https://x.com/TT_Exchange',
        'https://www.facebook.com/TT.official/',
        'https://www.linkedin.com/company/TT-exchange/',
        'https://www.tiktok.com/@TT_exchange',
        'https://t.me/TT_official',
      ],
    }],
  }
  const host = import.meta.server ? 'https://%%host_replace%%' : location.origin
  const route = useRoute()
  const switchLocalePath = useSwitchLocalePath()
  const { t } = useI18n()
  const image = `${host}/og-img.png`
  const title = t('TT 加密货币交易平台：比特币、以太币现货与合约交易')
  const description = t('领先的加密货币交易所及Web3公司，提供比特币 (BTC)、以太币 (ETH) 及多种主流币的现货与合约交易服务。立即透过 ttx.vip 开始安全交易，探索加密货币的无限可能！')

  const href = computed(() => `${host}${route.path}`)

  const link = computed(() => [
    ...locales.map(i => ({ rel: 'alternate', hreflang: i.code, href: `${host}${switchLocalePath(i.code)}` })),
    { rel: 'alternate', hreflang: 'x-default', href: `${host}${switchLocalePath('en')}` },
    { rel: 'canonical', href },
  ])

  useHead({
    link,
    script: [
      { type: 'application/ld+json', innerHTML: structData, key: 'structured-data' },
    ],
  })

  useSeoMeta({
    title,
    description,
    ogTitle: title,
    ogType: 'website',
    ogSiteName: SITE_NAME,
    ogImage: image,
    ogDescription: description,
    ogUrl: href,
    twitterTitle: title,
    twitterSite: '@TT_Exchange',
    twitterCard: 'summary_large_image',
    twitterImage: image,
    twitterDescription: description,
    googleSiteVerification: 'rkszsZNBqe9iXN3U-7O2w0Wjs3hyauQc5hKApWVvr5g',
  })
}

export function useTDK({ title, description, ...rest }) {
  useSeoMeta({
    title,
    description,
    ogTitle: title,
    ogDescription: description,
    twitterTitle: title,
    twitterDescription: description,
    ...rest,
  })
}
